// BOORO: tells the server the language the person reads BOORO in, so notices,
// mails and the log follow it.
import { productLocale } from "@booro/locale";
import { rpc } from "./rpc";
import type { UiLocale } from "./ui-locale";

export function reportUiLocale(locale: UiLocale): void {
  void rpc.booroLocale.set({ locale: productLocale(locale) }).catch(() => {});
}
